module.exports = __webpack_public_path__ + "static/media/7ICJ3.ab19c34d.jpg";